module.exports = __webpack_public_path__ + "static/img/banner4.14d295f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner4.jpg
// module id = FjYi
// module chunks = 1